import {
  buildAdventureDescriptionFromEvent,
  stripAdventureMeta,
} from "@/lib/adventure-helpers";

export type AdventureEditorMode = "create" | "edit" | "duplicate";

export type AdventureSaveTarget =
  | { kind: "insert" }
  | { kind: "update"; id: string };

export function getAdventureSaveTarget(
  mode: AdventureEditorMode,
  id: string | undefined,
): AdventureSaveTarget {
  if (mode !== "edit") return { kind: "insert" };
  if (!id) throw new Error("An activity ID is required in edit mode");
  return { kind: "update", id };
}

export function buildAdventureDescriptionForMode(
  mode: AdventureEditorMode,
  description: string | null | undefined,
  linkedEventId: string | null,
) {
  const visibleDescription = stripAdventureMeta(description);

  return mode === "edit" && linkedEventId
    ? buildAdventureDescriptionFromEvent(visibleDescription, linkedEventId)
    : visibleDescription;
}
